import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ActionSetStoreService } from 'app/services/store/action-set-store.service';
import { LoggedUserStoreService } from 'app/services/store/logged-user-store.service';

@Component({
    selector: 'app-new-profile-dialog',
    templateUrl: './new-profile-dialog.component.html',
    styleUrls: ['./new-profile-dialog.component.scss'],
    standalone: false
})
export class NewProfileDialogComponent implements OnInit {
    dialogRef = inject<MatDialogRef<NewProfileDialogComponent>>(MatDialogRef);

    availablesProfiles: Array<{ id: string, name: string }>;
    form: FormGroup;
    private _loggedUserStoreService = inject(LoggedUserStoreService);
    private _actionSetStoreService = inject(ActionSetStoreService);
    ngOnInit() {
        const actionSet: Array<string> = this._actionSetStoreService.getActionSets(this._loggedUserStoreService.getLoggedGroup().getGroupID())
            .reduce((acc, val) => {
                if (!acc.includes(val.moduleID)) { acc.push(val.moduleID) }
                return acc
            }, []);
        this.availablesProfiles = actionSet
            .map(_moduleID => {
                return { id: _moduleID, name: this._loggedUserStoreService.getActionSetNameByID(_moduleID) }
            })
        this.form = new FormGroup({
            name: new FormControl<string>(undefined, [Validators.required]),
            copyFrom: new FormControl<string | undefined>(undefined)
        })
    }
    onSubmit() {
        this.dialogRef.close(this.form.value)
    }
    onNoClick(): void {
        this.dialogRef.close();
    }
}
export type NewProfileDialogComponentResponse = { name: string, copyFrom?: string }
